import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IReportCompanyUnitModel } from '@apps-common/types/management/reporting'

export const getUnitsCancelledNonProcessedReport = async (): Promise<IReportCompanyUnitModel[]> =>
  axios.post('/management/unit/UnitsCancelledNonProcessedReport').then((res) => res.data?.data)

export const useManagementGetUnitsCancelledNonProcessedReport = (notify?: boolean, onSuccess?: (data: IReportCompanyUnitModel[]) => void) =>
  useMutation({
    mutationKey: ['getUnitsCancelledNonProcessedReport'],
    mutationFn: () => getUnitsCancelledNonProcessedReport(),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Successfully fetched non-processed cancellations report.')
      }
    },
    onError: (e: any) => {
      if (notify) {
        toastError(e?.message ? e?.message : 'Failed to fetch non-processed cancellations report.')
      }
    },
    throwOnError: false
  })
